import React, { Component } from 'react';
import { Growl } from 'primereact/growl';
import { Accordion, AccordionTab } from 'primereact/accordion';
import CapturaEditaInsidencia from "../componentes/CapturaEditaInsidencia";
import BusquedaDeIncidencia from "../componentes/BusquedaDeIncidencias";
import ImportarArchivoDeIncidencias from "../componentes/ImportarArchivoDeIncidencias";
export class AusentismosIncapacidades extends Component {
    constructor() {
        super();
        this.state = {

        }

    }
    componentDidMount() {

    }
    mostrarTab = (indiceTab) => {
        switch (indiceTab.index) {
            case 0:
                this.setState({ tabCaptura: <CapturaEditaInsidencia /> });
                this.setState({ tabImporta: null });  
                this.setState({ tabBusqueda: null });     
                break;
            case 1:
                   this.setState({ tabCaptura: null }); 
                   this.setState({ tabImporta: null });      
                    this.setState({ tabBusqueda: <BusquedaDeIncidencia /> });
                    break;
            case 2:
                  this.setState({ tabCaptura: null }); 
                  this.setState({ tabBusqueda: null });      
                  this.setState({ tabImporta: <ImportarArchivoDeIncidencias /> });
                  break;
            default:
                break;


        }
    }
    ocultarTab = (indiceTab) => {
        this.setState({ tabCaptura: null });
        this.setState({ tabBusqueda: null });

    }
    render() {
        let { tabCaptura ,tabBusqueda, tabImporta} = this.state;
        return (
            <div className="p-fluid">
                <Growl ref={(el) => this.growl = el} />
                
                    <div className="card card-w-title">
                        <h1>AUSENTISMOS E INCAPACIDADES</h1>                        
                            <Accordion onTabOpen={this.mostrarTab} onTabClose={this.ocultarTab}>
                                <AccordionTab header="CAPTURAR O EDITAR INCIDENCIAS">
                                    {tabCaptura}
                                </AccordionTab>

                                <AccordionTab header="BUSQUEDA DE INCIDENCIAS">
                                    {tabBusqueda}
                                </AccordionTab>
                                <AccordionTab header="IMPORTAR ARCHIVOS CON INCIDENCIAS">
                                  {tabImporta}
                                </AccordionTab>

                            </Accordion>

                        
                    </div>
                
            </div>

        );
    }

}